import { render, staticRenderFns } from "./LegislationsFilter.vue?vue&type=template&id=6ee7294b&"
import script from "./LegislationsFilter.vue?vue&type=script&lang=js&"
export * from "./LegislationsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports